import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import XIcon from '@mui/icons-material/X';

const MiamiLakesVzFarmersMarketKickoffEvent = () => {
  return (
    <Box
      sx={{
        p: { xs: 2, md: 4 },
        backgroundColor: '#fff',
        minHeight: '100vh',
        maxWidth: 900,
        mx: 'auto',
      }}
    >
      <Typography variant="h3" gutterBottom>
        Vision Zero Kick-off Event at Miami Lakes Farmer’s Market
      </Typography>

      <Typography paragraph>
        This past Saturday, July 19th, the Town of Miami Lakes hosted a kick-off for the Vision Zero
        initiative at the Farmer’s Market. The primary goal of this event was to commence the public
        engagement process towards the Town’s Transportation Master Plan, Greenways & Trails Master
        Plan, Complete Streets Master Plan updates. Furthermore, this event was centered around
        educating town residents about the Vision Zero concept, where no deaths or serious injuries
        are acceptable within the town’s transportation system.
      </Typography>

      <Box
        component="img"
        src={`${process.env.PUBLIC_URL}/images/news-kickoff-event1.jpg`}
        alt="Vision Zero Kickoff Event 1"
        sx={{ width: '100%', borderRadius: 2, my: 3 }}
      />

      <Typography paragraph>
        Throughout the event, information regarding Vision Zero, the Town’s various Master Plan
        updates, and transportation safety were disseminated to residents of Miami Lakes. Concerns
        for safer streets and transportation alternatives were shared under the shaded kiosk, along
        with bicycle helmets and other road safety materials.
      </Typography>

      <Box
        component="img"
        src={`${process.env.PUBLIC_URL}/images/news-kickoff-event2.jpg`}
        alt="Vision Zero Kickoff Event 2"
        sx={{ width: '100%', borderRadius: 2, my: 3 }}
      />

      <Typography paragraph>
        In total, twenty (20) bicycle helmets were distributed, as both pedestrians and cyclists
        were eager to participate and get a new helmet during this event. With well-designed, safe
        and more accessible infrastructure, every resident will be able to enjoy and feel safe when
        walking, biking, rolling, and driving in Miami Lakes!
      </Typography>

      <Box
        component="img"
        src={`${process.env.PUBLIC_URL}/images/news-kickoff-event3.jpg`}
        alt="Vision Zero Kickoff Event 3"
        sx={{ width: '100%', borderRadius: 2, my: 3 }}
      />

      <Typography paragraph>
        We invite you to continue participating as this public engagement effort just started. Join
        the conversation through our social media channels.
      </Typography>

<Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, mb: 2 }}>
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
    <InstagramIcon color="action" />
    <Link
      href="https://www.instagram.com/miamilakesvisionzero"
      target="_blank"
      rel="noopener noreferrer"
      underline="hover"
      color="inherit"
      sx={{ fontWeight: 500 }}
    >
      @miamilakesvisionzero
    </Link>
  </Box>
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
    <XIcon color="action" />
    <Link
      href="https://twitter.com/miamilakesvz"
      target="_blank"
      rel="noopener noreferrer"
      underline="hover"
      color="inherit"
      sx={{ fontWeight: 500 }}
    >
      @miamilakesvz
    </Link>
  </Box>
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
    <FacebookIcon color="action" />
    <Link
      href="https://www.facebook.com/share/1HS7Sy2A9Z/?mibextid=wwXIfr"
      target="_blank"
      rel="noopener noreferrer"
      underline="hover"
      color="inherit"
      sx={{ fontWeight: 500 }}
    >
      Vision Zero Miami Lakes
    </Link>
  </Box>
</Box>


      <Box
        component="img"
        src={`${process.env.PUBLIC_URL}/images/news-kickoff-event4.jpg`}
        alt="Vision Zero Kickoff Event 4"
        sx={{ width: '100%', borderRadius: 2, my: 3 }}
      />

<Typography paragraph>
  Check our website at{' '}
  <Link href="https://tinyurl.com/miamilakesconnected" target="_blank" rel="noopener">
    this link
  </Link>{' '}
  as we continue posting updates and upcoming events.
</Typography>

<Typography paragraph>
  Finally, this effort cannot be possible without your input. Check and fill out the online public
  survey using{' '}
  <Link href="https://arcg.is/04zv1u0" target="_blank" rel="noopener">
    this survey link
  </Link>
  .
</Typography>

<Typography paragraph>
  Para español:{' '}
  <Link href="https://arcg.is/04zv1u0" target="_blank" rel="noopener">
    haga clic aquí
  </Link>{' '}
  (seleccione español)
</Typography>


      <Box
        component="img"
        src={`${process.env.PUBLIC_URL}/images/news-kickoff-event5.jpg`}
        alt="Vision Zero Kickoff Event 5"
        sx={{ width: '100%', borderRadius: 2, my: 3 }}
      />

      <Typography paragraph>
        Overall, the event was a resounding success filled with smiles, fellowship, and hope for
        beautifully connected Miami Lakes.
      </Typography>
    </Box>
  );
};

export default MiamiLakesVzFarmersMarketKickoffEvent;
